import styled, { css } from 'styled-components';

import { Flex } from '@/components/base';

const IntegrationItemStyle = styled(Flex)<{ isIntegrated: boolean }>`
  padding: 12px 24px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 6px;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.primary100};
  }
  ${({ isIntegrated }) =>
    isIntegrated &&
    css`
      cursor: unset;
      &:hover {
        border: 1px solid ${(props) => props.theme.colors.gray400};
      }
    `}
  .logo-area {
    height: 28px;
    width: 240px;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
  }
  .desc-area {
    width: calc(100% - 252px);
    color: ${({ theme }) => theme.colors.gray800};
  }
`;

export { IntegrationItemStyle };
